import {
  GraduationCap,
  LayoutDashboard,
  UserCog,
  Users,
  UserCheck,
  ClipboardList,
  FileBarChart,
  ShieldCheck,
  Headphones,
  Coins,
  ArrowLeftRight,
  Users2,
  ScanFace,
  CandlestickChart,
  Wallet,
  Building2,
  Gift,
  LayoutGrid,
  Megaphone,
  Share2,
  Mail,
  MessagesSquare,
  Settings,
  Trophy,
  ShieldAlert,
  Bot,
  Brain,
  Sparkles,
  TrendingUp,
  Globe2,
  PhoneCall,
  ServerCog,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  label: string;
  to?: string;
  icon?: LucideIcon;
  badge?: string;
  children?: NavItem[];
}

/**
 * Full admin sidebar tree. Mirrors every section in the NXG Markets
 * reference (User-Manual sections 1–32). Routes that aren't wired yet
 * fall through to ModuleStub via the App.tsx catch-all.
 */
export const adminNav: NavItem[] = [
  { label: "Dashboard", to: "/admin/dashboard", icon: LayoutDashboard },
  {
    label: "Admin Profile",
    icon: UserCog,
    children: [
      { label: "Change Profile", to: "/admin/profile" },
      { label: "Notifications", to: "/admin/notifications" },
    ],
  },
  {
    label: "Manage Trader",
    icon: Users,
    children: [
      { label: "Trader Admin", to: "/admin/manage-client/trader-admin" },
      { label: "Trader Analysis", to: "/admin/manage-client/trader-analysis" },
    ],
  },
  {
    label: "IB Management",
    icon: UserCheck,
    children: [
      { label: "IB Registration", to: "/admin/ib/registration" },
      // Multi-level IB commission hidden for RDFX — single-level
      // "master gets full" rates model lives in Settings → IB Settings.
      // { label: "IB Commission", to: "/admin/ib/multilevel-commission" },
      // { label: "Custom Commission", to: "/admin/ib/multilevel-custom" },
      { label: "Commission Setup", to: "/admin/ib/commission-tree" },
      { label: "IB Settings", to: "/admin/settings/ib" },
      { label: "IB Tree", to: "/admin/ib/tree" },
      { label: "IB Chain", to: "/admin/ib/chain" },
      { label: "Commission Ledger", to: "/admin/ib/pending-commission" },
      { label: "IB Admin", to: "/admin/ib/admin-report" },
      { label: "IB Analysis", to: "/admin/ib/analysis" },
    ],
  },
  { label: "Copy Trading", to: "/admin/copy-trading", icon: Share2 },
  {
    label: "Manage Request",
    icon: ClipboardList,
    children: [
      { label: "Bank Request", to: "/admin/requests/bank" },
      { label: "Deposit Request", to: "/admin/requests/deposit" },
      { label: "Withdraw Request", to: "/admin/requests/withdraw" },
      { label: "Balance Transfer", to: "/admin/requests/balance-transfer" },
      { label: "IB Transfer", to: "/admin/requests/ib-transfer" },
      { label: "IB Withdraw", to: "/admin/requests/ib-withdraw" },
      { label: "UPI Request", to: "/admin/requests/upi" },
    ],
  },
  {
    label: "Reports",
    icon: FileBarChart,
    children: [
      { label: "Online Users", to: "/admin/reports/online-users" },
      { label: "IB Withdraw", to: "/admin/reports/ib-withdraw" },
      { label: "IB Commission Report", to: "/admin/reports/ib-commission-report" },
      { label: "Commission", to: "/admin/reports/ib-commission" },
      { label: "Trader Withdraw", to: "/admin/reports/trader-withdraw" },
      { label: "Trader Deposit", to: "/admin/reports/trader-deposit" },
      { label: "Blocked Users", to: "/admin/reports/blocked-users" },
      { label: "Activity Log", to: "/admin/reports/activity-log" },
      { label: "Bonus Report", to: "/admin/reports/bonus" },
      { label: "IB Fund Transfer", to: "/admin/reports/ib-fund-transfer" },
      { label: "External Fund Transfer", to: "/admin/reports/external-fund-transfer" },
      { label: "IB Balance Add", to: "/admin/reports/ib-balance-add" },
      { label: "Ledger Report", to: "/admin/reports/ledger" },
      { label: "Individual Ledger", to: "/admin/reports/individual-ledger" },
      // { label: "Call Logs", to: "/admin/reports/call-logs" }, // hidden for RDFX
      { label: "Credit Report", to: "/admin/reports/credit" },
    ],
  },
  {
    label: "Manage Admin",
    icon: ShieldCheck,
    children: [
      { label: "Role Management", to: "/admin/admins/groups" },
      { label: "Admin List", to: "/admin/admins/list" },
      { label: "Platform Control", to: "/admin/modules" },
    ],
  },
  {
    label: "Manager Settings",
    icon: Headphones,
    children: [
      { label: "Add Manager", to: "/admin/managers/add" },
      { label: "Manager List", to: "/admin/managers/list" },
      { label: "RM Targets", to: "/admin/managers/targets" },
    ],
  },
  {
    label: "Finance",
    icon: Coins,
    children: [
      { label: "Balance Management", to: "/admin/finance/balance" },
      { label: "Wallet Credit", to: "/admin/finance/credit" },
      { label: "Fund Management", to: "/admin/finance/fund" },
      { label: "Admin Deposit", to: "/admin/finance/admin-deposit" },
      { label: "Admin Withdraw", to: "/admin/finance/admin-withdraw" },
    ],
  },
  {
    label: "Fund Transfer",
    icon: ArrowLeftRight,
    children: [
      { label: "Internal", to: "/admin/fund-transfer/internal" },
      { label: "External", to: "/admin/fund-transfer/external" },
    ],
  },
  {
    label: "Group Settings",
    icon: Users2,
    children: [
      { label: "Group Manager", to: "/admin/groups/create" },
      { label: "Group List", to: "/admin/groups/list" },
      { label: "Manage IB Group", to: "/admin/groups/ib" },
      { label: "Manage CPA IB Group", to: "/admin/groups/cpa-ib" },
    ],
  },
  {
    label: "KYC Management",
    icon: ScanFace,
    children: [
      { label: "KYC Settings", to: "/admin/kyc/settings" },
      { label: "KYC Request", to: "/admin/kyc/request" },
    ],
  },
  {
    label: "Manage Trade",
    icon: CandlestickChart,
    children: [
      { label: "Trading Report", to: "/admin/trade/report" },
      { label: "Trade Commission", to: "/admin/trade/commission" },
    ],
  },
  {
    label: "Manage Accounts",
    icon: Wallet,
    children: [
      { label: "Live Accounts", to: "/admin/accounts/live" },
      { label: "Demo Accounts", to: "/admin/accounts/demo" },
      { label: "MT5 Connection", to: "/admin/mt5/connection" },
    ],
  },
  {
    label: "Manage Banks",
    icon: Building2,
    children: [{ label: "Company Bank List", to: "/admin/banks/company" }],
  },
  {
    label: "Offers",
    icon: Gift,
    children: [
      { label: "Create Bonus", to: "/admin/offers/create" },
      { label: "Bonus Packages", to: "/admin/offers/packages" },
      { label: "Bonus Report", to: "/admin/offers/report" },
      { label: "Trade & Win Rewards", to: "/admin/offers/rewards" },
      { label: "Reward Dashboard", to: "/admin/offers/reward-dashboard" },
      { label: "Reward Claims", to: "/admin/offers/reward-claims" },
    ],
  },
  { label: "RD Education", to: "/admin/education", icon: GraduationCap },
  { label: "Support Tickets", to: "/admin/support", icon: MessagesSquare },
  {
    label: "Settings",
    icon: Settings,
    children: [
      { label: "Company Setup", to: "/admin/settings?tab=company" },
      { label: "Branding & Logo", to: "/admin/settings?tab=branding" },
      { label: "Dashboard Theme", to: "/admin/settings?tab=dashboard" },
      { label: "Social Links", to: "/admin/settings?tab=social" },
      { label: "Footer Links", to: "/admin/settings?tab=footer" },
      { label: "SMTP Setup", to: "/admin/settings?tab=smtp" },
      { label: "Finance Setup", to: "/admin/settings/finance" },
      { label: "Payment Gateway", to: "/admin/settings/payment-gateway" },
      { label: "Trading Platforms", to: "/admin/settings/platforms" },
      { label: "IB Settings", to: "/admin/settings/ib" },
      { label: "Security Settings", to: "/admin/settings/security" },
      { label: "Trader Settings", to: "/admin/settings/trader" },
      { label: "Trader Sidebar", to: "/admin/settings/trader-sidebar" },
      // { label: "Mobile App", to: "/admin/settings/mobile" }, // hidden for RDFX
      { label: "Email Templates", to: "/admin/email" },
    ],
  },
];
